import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-primary h-full" }
const _hoisted_2 = { class: "w-full h-full bg-gradient-to-r from-primary/10 via-primary/50 to-primary" }
const _hoisted_3 = { class: "text-center flex flex-col justify-center xl:pt-32 xl:text-left h-full container mx-auto" }
const _hoisted_4 = {
  key: 0,
  class: "h1"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-accent" }
const _hoisted_7 = {
  key: 1,
  class: "h1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-accent" }, "Language of algorithms", -1)
const _hoisted_10 = { class: "max-w-sm xl:max-w-xl mx-auto xl:mx-0 mb-6 xl:mb-14" }
const _hoisted_11 = { class: "flex justify-center xl:hidden relative" }
const _hoisted_12 = { class: "hidden xl:flex" }
const _hoisted_13 = { class: "w-[1200px] h-full absolute right-0 bottom-0" }
const _hoisted_14 = { class: "w-full h-full max-w-[500px] max-h-[678px] absolute -bottom-32 lg:bottom-0 lg:right-[4%] 2xl:right-[30%]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsButton = _resolveComponent("ProjectsButton")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (Boolean(_ctx.userStore.user))
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, [
              _createTextVNode("Hi, " + _toDisplayString(_ctx.userStore.user.name), 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userStore.user.surname), 1)
            ]))
          : (_openBlock(), _createElementBlock("h1", _hoisted_7, [
              _createTextVNode(" Sculpting Success in the"),
              _hoisted_8,
              _hoisted_9
            ])),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.subIntroText), 1),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_ProjectsButton)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ProjectsButton)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Avatar)
      ])
    ])
  ]))
}